<main class="wrapper">
  <app-header (toggleMenuSidebar)="toggleMenuSidebar()"></app-header>

  <app-menu-sidebar></app-menu-sidebar>

  <div class="content-wrapper pl-lg-3">
    <router-outlet></router-outlet>
  </div>

  <div id="sidebar-overlay" (click)="toggleMenuSidebar()"></div>
</main>
